<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <div class="page-header">
        <div class="page-title">
          {{ $t('editpage.text1') }}
        </div>
      </div>
      <div class="info-box">
        <div
          class="avatar"
          :style="{
            backgroundImage:
              'url(' + $store.state.imgUrl + modelForm.avatar + ')'
          }">
          <div class="camera">
            <input
              id="file"
              @change="handleFileChange"
              type="file"
              name="file" />
          </div>
        </div>
      </div>
      <el-form :model="modelForm" label-width="80px" label-position="top">
        <el-form-item :label="$t('editpage.text8')">
          <el-input v-model="modelForm.company"></el-input>
        </el-form-item>
        <el-form-item :label="$t('editpage.text3')">
          <el-input v-model="modelForm.email" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('editpage.text4')">
          <el-input
            type="textarea"
            rows="5"
            v-model="modelForm.profile"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button
        type="primary"
        @click="handleSave"
        class="block el-button--special"
        style="color: #ffffff"
        >{{ $t('save') }}</el-button
      >
    </div>
  </div>
</template>
<script>
import {
  postMcnImageUpload,
  postMcnUserUpdate,
  postUserInfoMcn
} from '@/api/mcn'
import { Toast } from 'mint-ui'

export default {
  name: 'McnEdit',
  components: {},
  data() {
    return {
      modelForm: {
        company: '',
        email: '',
        avatar: ''
      }
    }
  },
  created() {
    this.modelForm = JSON.parse(localStorage.getItem('user_info'))
  },
  methods: {
    handleSave() {
      let modelForm = {
        company: this.modelForm.company,
        profile: this.modelForm.profile,
        avatar: this.modelForm.avatar
      }
      console.log(modelForm)
      postMcnUserUpdate(modelForm).then((res) => {
        if (res.errorCode === 0) {
          Toast({
            message: this.$t('editpage.text9'),
            iconClass: 'icon icon-success'
          })
          postUserInfoMcn().then((res) => {
            this.$store.dispatch('UserInfo', res.data)
            this.$router.push({ path: '/mcn/account' })
          })
        }
      })
    },
    handleFileChange(e) {
      console.log(e)
      let files = e.target.files
      if (files) {
        const file = files[0]
        console.log(file)
        if (file.size > 1024 * 1024 * 3) {
          alert('文件大小不能超过3M!')
          return false
        } else {
          const formData = new FormData()
          formData.append('image_file', file)
          console.log(formData)
          postMcnImageUpload(formData).then((res) => {
            this.modelForm.avatar = res.data.path
          })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mcn/edit.vue